import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEventFormInquiry = (
    clickText: InquiryButtonTypeName | string,
    source: GTMEventApplicationSourceSection | string,
    vendorName: string,
    offerName: string
) => {
    const gtmData = {
        event: "form_inquiry",
        event_label: clickText,
        event_category: source,
        event_category2: vendorName,
        event_category3: offerName
    };
    hitGoogleTagManager(gtmData);
};
